export const appConfig = {
	backendUrl: process.env.REACT_APP_BE,
	useMockData: false,
};
